<template>
    <ul>
        <menu-primary-item
            v-for="(menu, i) in items"
            :key="i"
            :modelValue="menu"
            @update:modelValue="updateItem(i, $event)"
        ></menu-primary-item>
    </ul>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import MenuPrimaryItem from "./MenuPrimaryItem.vue";

const props = defineProps({
    value: {
        type: Array,
        default: () => []
    },
    items: {
        type: Array,
    }
});

const emit = defineEmits(['update:value']);

const updateItem = (index, newValue) => {
    const updatedValue = [...props.value];
    updatedValue[index] = newValue;
    emit('update:value', updatedValue);
};
</script>

<style scoped>
/* Your styles here */
</style>
